import { v4 as uuidv4 } from "uuid";

import { ScoreAggregation } from "evaluation/ScoreAggregation";

export const WidgetKind = {
	EVALUATION_SCORES: "evaluation_scores",
	EVALUATION_HISTORY: "evaluation_history"
} as const;

export type WidgetKindType = (typeof WidgetKind)[keyof typeof WidgetKind];

export abstract class Widget {
	readonly uuid: string;
	readonly name: string;
	readonly type: WidgetKindType;

	constructor(name: string, type: WidgetKindType) {
		this.uuid = uuidv4();
		this.name = name;
		this.type = type;
	}

	public static ofType(type: WidgetKindType, name: string): Widget {
		switch (type) {
			case WidgetKind.EVALUATION_SCORES:
				return new EvaluationScoresWidget(name);
			case WidgetKind.EVALUATION_HISTORY:
				return new EvaluationHistoryWidget(name);
			default:
				throw new Error(`Unknown widget type: ${type}`);
		}
	}
}

export class EvaluationScoresWidget extends Widget {

	public cluster: string | null = null;

	// Which number a scored competence contributes to the pie. The default is
	// set here so a widget that is not yet saved carries the member: the editor
	// patches it with a replace, which needs the member to exist. Widgets
	// loaded from the server always carry it, because the Java class
	// serialises it.
	public scoreAggregation: ScoreAggregation = ScoreAggregation.LATEST;

	constructor(name: string) {
		super(name, WidgetKind.EVALUATION_SCORES);
	}
}

export class EvaluationHistoryWidget extends Widget {
	constructor(name: string) {
		super(name, WidgetKind.EVALUATION_HISTORY);
	}
}

export type DashboardBlueprint = {
	widgets: Array<Widget>;
};

export type Dashboard = {
	widgets: Array<Widget>;
};
